import { render, staticRenderFns } from "./hebeiCourseList.vue?vue&type=template&id=4b71ad82"
import script from "./hebeiCourseList.vue?vue&type=script&lang=js"
export * from "./hebeiCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports